






























































import { Component,Prop, Vue } from 'vue-property-decorator';
import $ from 'jquery';
import * as qiniu from 'qiniu-js';
import { joinUpdate,quitTeam } from '@/api/team/team'
import { SERVER_HOST } from '@/global/constants'
import { uploadOss } from '@/global/utils'
@Component
export default class TeamDetail extends Vue{
    @Prop() private team!: object;
    private visible :boolean = false;
    private isUploading: boolean = false;
    private percent:number = 101;
    // 表单数据
    private formData: object = {
        title: '',
        logo: '',
        notice: '',
        name: '',
        mobile: ''
    };
    private ruleValidate = {
        title: [{ required: true, message: '团队名称不能为空', trigger: 'blur' }],
        logo: [{ required: false}],
        notice: [{ required: true, message: '请正确输入团队公告', trigger: 'blur' }],
        name: [{ required: true, message: '负责人姓名不能为空', trigger: 'blur' }],
        mobile: [{ required: true, message: '负责人手机号不能为空', trigger: 'blur' }],

    };
    get userInfo() {
        return this.$store.state.userInfo;
    }
    private async upLoad(e){
        let file = e.target.files[0];
        if(!file) return ;
        let sid = (this.team as any).team_id;
        let times = new Date().getTime();
        let extension = file.name.split('.')[1];
        let key = `${sid}/${times}.${extension}`;
        this.isUploading = true
        uploadOss(file, key).then(res => {
            this.isUploading = false;
            this.percent = 101;
            (this.formData as any).logo = res
            alert('上传完成');
        }).catch(err => {
            console.log(err)
            alert('上传失败');
        })
    }
    // private upLoad(e){
    //     let token = '/v1/sdk/qiniu/token.json';
    //     let sid = (this.team as any).team_id;
    //     let times = new Date().getTime();

    //     let file = e.target.files[0];
    //     if(!file) return ;
    //     let extension = file.name.split('.')[1];
    //     let key = `${sid}/${times}.${extension}`;

    //     $.ajax({
    //         type: "GET",
    //         url: SERVER_HOST + token,
    //         xhrFields: {
    //             withCredentials: true,
    //         },
    //         error: function(err){
    //             console.log(err);
    //         },
    //         success: (data) => {
    //             let config = {
    //                 useCdnDomain: true,
    //                 region: null,
    //             };
    //             let putExtra = {
    //                 fname: "",
    //                 params: {},
    //                 mimeType: null,
    //                 domain: 'https://static.cdn.longmaosoft.com'
    //             };
    //             let observer = {
    //                 next: (res) => {
    //                     this.isUploading = true
    //                     this.percent = Math.floor(res.total.percent)
    //                 },
    //                 error(err){
    //                     alert('上传失败');
    //                 },
    //                 complete: (res) => {
    //                     alert('上传完成');
    //                     this.isUploading = false;
    //                     this.percent = 101;
    //                     (this.formData as any).logo = `https://static.cdn.longmaosoft.com/${res.key}`
    //                 }
    //             };
    //             let observable = qiniu.upload(file, key, data.result, putExtra, config)
    //             let subscription = observable.subscribe(observer);
    //         }
    //     });
    // }
    // 显示modal
    private showModal(){
        let team:any = this.team
        this.formData = {
            title:team.title||'',
            logo:team.logo||'',
            notice:team.notice||'',
            name:team.name||'',
            mobile:team.mobile||''
        }
        this.visible = true;
    }
    // 隐藏modal
    private handleCancel(){
        this.visible = false
    }
    private handleValidate() {
        (this.$refs.formValidate as any).validate(valid => {
            if (valid) {
                this.handleSubmit();
            } else {
                return false;
            }
        });
    }
    private async handleSubmit(){
        let res:any = await joinUpdate(this.formData)
        if(res.code == '200'){
            this.visible = false
            this.$store.dispatch('getTeam');
            this.$Message.success('信息更改成功');
        }
    }
    // 退出团队confirm
    private showConfirm(){

        this.$Modal.confirm({
            title: '退出团队',
            content: '退出团队后，已做的任务报酬将结算给团队管理员，确定退出团队吗？',
            okText: '退出团队',
            cancelText: '取消',
            onOk: () => {
                this.handleExitTeam();
            },
        });
    }
    // 退出团队
    private async handleExitTeam(){
        let res = quitTeam({tid:(this.team as any).team_id})
        this.$store.dispatch('logoutUser');
    }
}
